<template>
  <v-container>
    <v-row>
      <v-col>
        <h3>Qual é a meta?</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="Valor"
          v-model="valorMeta"
          v-on:input="emitInputChange('valorMeta', valorMeta)"
          v-money="moneyMask"
          prefix="R$"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          :items="itemsPrazo"
          v-model="prazoMeta"
          v-on:input="emitInputChange('prazoMeta', prazoMeta)"
          value="Mensal"
          label="Prazo"
          prepend-icon="event"
        ></v-select>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <h3>Qual é o ticket médio?</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Valor"
              v-model="ticketMedio"
              v-on:input="emitInputChange('ticketMedio', ticketMedio)"
              v-money="moneyMask"
              prefix="R$"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <h3>Etapas do funil de vendas</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              :items="itemsEtapaFunil"
              v-model="etapasFunil"
              v-on:input="emitInputChange('etapasFunil', etapasFunil)"
              value="oportunidades"
              label="Selecione"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { VMoney } from 'v-money';

export default {
  directives: { money: VMoney },
  data: function() {
    return {
      valorMeta: null,
      ticketMedio: null,
      etapasFunil: null,
      prazoMeta: '',

      itemsPrazo: ['Semanal', 'Mensal', 'Trimestral', 'Semestral', 'Anual'],
      itemsEtapaFunil: [
        { text: 'Oportunidades, Visitas, Propostas', value: 'oportunidades' },
        { text: 'Leads, Demonstração, Propostas', value: 'leadsDemo' },
        { text: 'Prospects, Apresentações, Orçamentos', value: 'prospect' },
        {
          text: 'Leads, Contato(s) Efetivo(s), Visitar Realizadas',
          value: 'leadsContatos'
        },
        { text: 'Contatos Únicos, Agendados, Comparecidos', value: 'contatos' }
      ],
      moneyMask: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    };
  },
  methods: {
    emitInputChange(fieldName, value) {
      this.$emit('input-change', fieldName, value);
    }
  }
};
</script>

<style>
</style>